import {
  RESET_FORM_FIELDS,
  RESET_SELECTED_ITEMS,
  SET_ASSIGN_SEARCH_VALUE,
  SET_ASSIGNED_FORMS,
  SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_ITEMS,
  SET_CURRENT_SELECTED_ITEMS,
  SET_CURRENT_SHOW_SELECTED_ITEMS,
  SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION,
  SET_CURRENT_TAB,
  SET_CURRENT_TOGGLE_ITEM_FUNCTION,
  SET_FILES,
  SET_FORM_SUBMISSION_ID,
  SET_FORMS,
  SET_NEW_FORM_FIELDS,
  SET_SELECTED_END_DATE,
  SET_SELECTED_LOCATION,
  SET_SELECTED_LOCATION_GROUPS,
  SET_SELECTED_LOCATIONS,
  SET_SELECTED_ORG_GROUPS,
  SET_SELECTED_ROLE_GROUPS,
  SET_SELECTED_ROLES,
  SET_SELECTED_ROLES_FILTER,
  SET_SELECTED_START_DATE,
  SET_SELECTED_STATUS,
  SET_SELECTED_STORES,
  SET_SELECTED_USERS,
  SET_SHOW_FORM_SUBMISSION,
  SET_SHOW_SELECTED_LOCATION_GROUPS,
  SET_SHOW_SELECTED_LOCATIONS,
  SET_SHOW_SELECTED_ORG_GROUPS,
  SET_SHOW_SELECTED_ROLES,
  SET_SHOW_SELECTED_STORES,
  SET_SHOW_SELECTED_USERS,
  SET_SHOW_SELECTED_USERS_ITEMS,
  SET_SUBMISSION,
  SET_SUBMISSION_MODAL_DATA,
  SET_USER_STORES,
  SET_LOADING_FORMS,
  SET_FORM_SECTIONS,
  SET_FILL_FORM_MODAL_DATA,
} from './constants'

const initialFormFields = [
  { index: 0, type: 'heading', text: 'Untitled Form', fontSize: 'H3' },
  {
    index: 1,
    type: 'paragraph',
    text: 'This is my form. Please fill it out. Thanks!',
  },
]

const initialState = {
  newFormFields: initialFormFields,
  forms: [],
  assignedForms: [],
  submission: [],
  userStores: [],
  selectedStatus: null,
  selectedLocation: null,
  selectedStartDate: null,
  selectedEndDate: null,
  files: [],
  currentItems: 'groupOrgs',
  currentToggleFunction: 'toggleOrgGroups',
  assignSearchValue: '',
  currentHideSelectedItemsFunction: 'setHideSelectedOrgGroups',
  currentShowSelectedItemsFunction: 'setShowSelectedOrgGroups',
  currentShowSelectedItems: 'showSelectedOrgGroups',
  currentSelectedItems: 'selectedOrgGroups',
  assignSearchValue: '',
  selectedOrgGroups: [],
  selectedUsers: [],
  selectedLocationGroups: [],
  selectedLocations: [],
  selectedRoles: [],
  selectedStores: [],
  selectedRoleGroups: [],
  showSelectedOrgGroups: false,
  showSelectedUsers: false,
  showSelectedUsersItems: false,
  showSelectedLocationGroups: false,
  showSelectedLocations: false,
  showSelectedStores: false,
  showSelectedRoles: false,
  currentTab: 'category',
  showFormSubmission: false,
  selectedFormSubmissionId: null,
  formsLoading: false,
  submissionModalData: { show: false, user_id: '', submission_id: '' },
  formSections: [],
  fillFormModalData: { show: false, formId: null },
}

const formReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NEW_FORM_FIELDS:
      return {
        ...state,
        newFormFields: action.payload,
      }
    case RESET_FORM_FIELDS:
      return {
        ...state,
        newFormFields: initialFormFields,
      }
    case SET_FORMS:
      return {
        ...state,
        forms: action.payload,
      }
    case SET_ASSIGNED_FORMS:
      return {
        ...state,
        assignedForms: action.payload,
      }
    case SET_SUBMISSION:
      return {
        ...state,
        submission: action.payload,
      }
    case SET_SELECTED_LOCATION:
      return {
        ...state,
        selectedLocation: action.payload,
      }
    case SET_SELECTED_STATUS:
      return {
        ...state,
        selectedStatus: action.payload,
      }
    case SET_SELECTED_START_DATE:
      return {
        ...state,
        selectedStartDate: action.payload,
      }
    case SET_SELECTED_END_DATE:
      return {
        ...state,
        selectedEndDate: action.payload,
      }
    case SET_FILES:
      return {
        ...state,
        files: action.payload,
      }
    case SET_USER_STORES:
      return {
        ...state,
        userStores: action.payload,
      }
    case SET_CURRENT_TAB:
      return {
        ...state,
        currentTab: action.currentTab,
      }
    case SET_CURRENT_SELECTED_ITEMS:
      return {
        ...state,
        currentSelectedItems: action.currentSelectedItems,
      }
    case SET_SELECTED_ORG_GROUPS:
      return {
        ...state,
        selectedOrgGroups: action.orgGroups,
      }
    case SET_SELECTED_USERS:
      return {
        ...state,
        selectedUsers: action.users,
      }
    case SET_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        selectedLocationGroups: action.locationGroups,
      }
    case SET_SELECTED_LOCATIONS:
      return {
        ...state,
        selectedLocations: action.locations,
      }
    case SET_SELECTED_ROLE_GROUPS:
      return {
        ...state,
        selectedRoleGroups: action.roleGroups,
      }
    case SET_SELECTED_ROLES:
      return {
        ...state,
        selectedRoles: action.roles,
      }
    case SET_SELECTED_STORES:
      return {
        ...state,
        selectedStores: action.stores,
      }
    case SET_CURRENT_ITEMS:
      return {
        ...state,
        currentItems: action.currentItems,
      }
    case SET_CURRENT_TOGGLE_ITEM_FUNCTION:
      return {
        ...state,
        currentToggleFunction: action.currentToggleFunction,
      }
    case SET_ASSIGN_SEARCH_VALUE:
      return {
        ...state,
        assignSearchValue: action.assignSearchValue,
      }
    case SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentHideSelectedItemsFunction:
          action.currentHideSelectedItemsFunction,
      }
    case SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION:
      return {
        ...state,
        currentShowSelectedItemsFunction:
          action.currentShowSelectedItemsFunction,
      }
    case SET_CURRENT_SHOW_SELECTED_ITEMS:
      return {
        ...state,
        currentShowSelectedItems: action.currentShowSelectedItems,
      }
    case SET_SHOW_SELECTED_ORG_GROUPS:
      return {
        ...state,
        showSelectedOrgGroups: action.showSelectedOrgGroups,
      }
    case SET_SHOW_SELECTED_USERS:
      return {
        ...state,
        showSelectedUsers: action.showSelectedUsers,
      }
    case SET_SHOW_SELECTED_USERS_ITEMS:
      return {
        ...state,
        showSelectedUsersItems: action.showSelectedUsersItems,
      }
    case SET_SHOW_SELECTED_LOCATION_GROUPS:
      return {
        ...state,
        showSelectedLocationGroups: action.showSelectedLocationGroups,
      }
    case SET_SHOW_SELECTED_LOCATIONS:
      return {
        ...state,
        showSelectedLocations: action.showSelectedLocations,
      }
    case SET_SHOW_SELECTED_STORES:
      return {
        ...state,
        showSelectedStores: action.showSelectedStores,
      }
    case SET_SHOW_SELECTED_ROLES:
      return {
        ...state,
        showSelectedRoles: action.showSelectedRoles,
      }
    case SET_SELECTED_ROLES_FILTER:
      return {
        ...state,
        rolesFilter: action.value,
      }
    case RESET_SELECTED_ITEMS:
      return {
        ...state,
        selectedLocationGroups: [],
        selectedLocations: [],
        selectedStores: [],
        selectedOrgGroups: [],
        selectedRoles: [],
        selectedUsers: [],
        selectedRoleGroups: [],
      }

    case SET_SHOW_FORM_SUBMISSION:
      return { ...state, showFormSubmission: action.payload }
    case SET_FORM_SUBMISSION_ID:
      return { ...state, selectedFormSubmissionId: action.payload }

    case SET_LOADING_FORMS:
      return { ...state, formsLoading: action.payload }
    case SET_SUBMISSION_MODAL_DATA:
      return {
        ...state,
        submissionModalData: action.payload,
      }
    case SET_FORM_SECTIONS:
      return { ...state, formSections: action.payload }
    case SET_FILL_FORM_MODAL_DATA:
      return { ...state, fillFormModalData: action.payload }
    default:
      return state
  }
}

export default formReducer
